import React from "react";
import Tip from "../../components/utility/tip";
import rq from "../utility/rq";
import Spinner from "../../components/utility/spinner";
import MessageBox from "../../components/utility/message-box";
import { DD_MM_YY, toExactFixted, extractDataFromTable, print } from "../../components/utility/util-methods";
import QuestionBox from "../../components/utility/question-box";
import SelectMenu from "../../components/utility/select-menu";
import productStore from "../../store/product-store";
import { productConstant } from "../../constants/constants";

export default class CreateInspectionEntry extends React.Component {
    constructor() {
        super();
        this.state = {
            propError: {},
            productList: productStore.getAll(),
            showSpinner: false,
            nozels: [],
            productData: []

        };
        this.selectNozel = {};
        this.inspectionDate = null;
        this.totalStock = null;
        this.messageBox = null;
        this.questionBox = null;
        this.saveInspection = this.saveInspection.bind(this);
        this.handleProductStoreChange = this.handleProductStoreChange.bind(this);
        this.producdMenuReset = false;
        this.selectedProduct = null;
        this.handeleNozelNumber = this.handeleNozelNumber.bind(this);
    }


    askQuestion(msg, yesCallBack, noCallBack) {
        this.questionBox = <QuestionBox questionMsg={msg} yesCallBack={yesCallBack} noCallBack={noCallBack}></QuestionBox>;
        this.setState(this.state);
    }
    saveInspection(data) {
        this.askQuestion(`Do you watnt to save this Inspection   ?`, () => {
            let jsonData = {}
            jsonData.readingSum = this.readingSum;
            jsonData.totalStock = this.refs.totalStock.value;
            jsonData.totalBeforeStock = this.totalBeforeStock



            this.setState({ showSpinner: true })
            rq.postJson(`/api/v1/mis/dsr-inpection/create`, { date: this.refs.inspectionDate.value, jsonData, productId: this.selectedProduct.productId }).then((data) => {
                this.messageBox = MessageBox.showMessage("Last inspection createing successfully", true, this);
                this.producdMenuReset = true;
                this.refs.inspectionDate.value = "";
                this.selectedProduct = null;
                this.refs.totalBeforeStock.value = "";
                this.refs.readingSum.value = "";
                this.refs.totalStock.value = "";

                this.setState({ showSpinner: false });

            }).catch((err) => {
                if (err.msg) {
                    this.messageBox = MessageBox.showMessage(err.msg, false, this);
                } else {
                    this.messageBox = MessageBox.showMessage("Last inspection createing  failed !!!", false, this);
                }
                this.setState({ showSpinner: false });


            });


            this.questionBox = null;
            this.forceUpdate();

        }, () => {

            this.questionBox = null;
            this.forceUpdate();
        });


    }

    onsubmit() {
        var propError = {};
        if (this.refs.inspectionDate.value) {
            delete propError.inspectionDate;
        } else
            propError.inspectionDate = true;


        if (this.refs.totalStock.value) {
            delete propError.totalStock;
        } else
            propError.totalStock = true;

        if (this.selectedProduct) {
            delete propError.productId;
        } else
            propError.productId = true;

        if (this.refs.totalBeforeStock.value) {
            delete propError.totalBeforeStock;
        } else
            propError.totalBeforeStock = true;

        if (this.refs.readingSum.value) {
            delete propError.readingSum;
        } else
            propError.readingSum = true;


        if (Object.keys(propError).length > 0) {
            this.setState({ propError, productData: [] });
        } else {
            this.state.propError = propError;
            this.saveInspection();
        }
    }
    handeleInspectionDate(e) {
        this.inspectionDate = e.target.value;
    }
    handeltotalStock(e) {
        this.totalStock = e.target.value;
    }
    handeltotalBeforeStock(e) {
        this.totalBeforeStock = e.target.value;
    }
    handeleNozelNumber(e) {
        //console.log(nozel, e.target.value
        this.readingSum = e.target.value
    }
    onProductSelect(product) {
        if (product) {
            this.selectedProduct = product;
            const propError = Object.assign({}, this.state.propError);
            delete propError.productId;
            this.setState({ propError });
        }

    }
    handleProductStoreChange() {
        this.setState({ productList: productStore.getAll() });
    }
    componentWillMount() {
        productStore.on(productConstant.PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
    }
    componentWillUnmount() {
        productStore.removeListener(productConstant.PRODUCTS_STORE_CHANGE, this.handleProductStoreChange);
    }
    componentDidUpdate() {
        this.producdMenuReset = false;
    }
    render() {
        return (
            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>

                <div className="smallholder" >
                    <p className="formMsg">Create Last inspection Entry</p>
                    <table className="formTable">
                        <tbody>
                            <tr style={{ display: "flex", justifyContent: "center" }}>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.productId}
                                        pointerStyle={{}}
                                        msg={"Select a product "}
                                    />
                                    <SelectMenu
                                        data={this.state.productList}
                                        onSelect={this.onProductSelect.bind(this)}
                                        tabIndex="1"
                                        text="Select a product"
                                        ky="productId"
                                        vl="productName"
                                        reset={this.producdMenuReset}
                                    >
                                    </SelectMenu>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.readingSum}
                                        pointerStyle={{}}
                                        msg={"Enter Reading Sum "}
                                    />
                                    <p className="label">Enter inspection Reading Sum</p>
                                    <input
                                        tabIndex="2"
                                        type="number"
                                        className="formControl inputBox"
                                        placeholder="Enter inspection Reading Sum"
                                        onChange={this.handeleNozelNumber.bind(this)}
                                        ref="readingSum"

                                    />
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.inspectionDate}
                                        pointerStyle={{}}
                                        msg={"Enter inspection date"}
                                    />
                                    <p className="label">inspection Date</p>
                                    <input
                                        tabIndex="15"
                                        type="date"
                                        className="formControl inputBox"
                                        placeholder="Enter inspection Date"
                                        onChange={this.handeleInspectionDate.bind(this)}
                                        ref="inspectionDate"

                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.totalStock}
                                        pointerStyle={{}}
                                        msg={"Enter Total Stock"}
                                    />
                                    <p className="label">Enter Total Stock</p>
                                    <input
                                        tabIndex="16"
                                        type="number"
                                        className="formControl inputBox"
                                        placeholder="Enter Total Stock"
                                        onChange={this.handeltotalStock.bind(this)}
                                        ref="totalStock"

                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <Tip
                                        showOn={this.state.propError.totalBeforeStock}
                                        pointerStyle={{}}
                                        msg={"Enter stock In quantity"}
                                    />
                                    <p className="label">Enter stock In quantity Before inspection Time (day of insepction)</p>
                                    <input
                                        tabIndex="16"
                                        type="number"
                                        className="formControl inputBox"
                                        placeholder="Enter stock In quantity"
                                        onChange={this.handeltotalBeforeStock.bind(this)}
                                        ref="totalBeforeStock"

                                    />
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <button
                        tabIndex="17"
                        className="btn btnOk btnRight"
                        onClick={this.onsubmit.bind(this)}
                    >
                        Submit
                 </button>
                    <div className="clear"></div>
                </div>

                {this.messageBox}
                {this.questionBox}
                {this.state.showSpinner ? <Spinner></Spinner> : null}

            </div>
        );
    }
}   


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/last-inspection-entry.jsx